export const LOADING = 'community.LOADING';
export const LOADED = 'community.LOADED';